import { render } from "./insightResults.vue?vue&type=template&id=8509b55e&scoped=true"
import script from "./insightResults.vue?vue&type=script&lang=js"
export * from "./insightResults.vue?vue&type=script&lang=js"

import "./insightResults.vue?vue&type=style&index=0&id=8509b55e&scoped=true&lang=css"

import exportComponent from "/Users/andrew/Documents/Code/SeoBiz/AdminApp/FrontEnd/clientapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8509b55e"]])

export default __exports__